import { render, staticRenderFns } from "./modal-similar.vue?vue&type=template&id=67b7a908&"
import script from "./modal-similar.vue?vue&type=script&lang=js&"
export * from "./modal-similar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports